module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex pb-navs"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "alifont icon-xpsousuo"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageInfo.orderNo),
      expression: "pageInfo.orderNo"
    }],
    staticClass: "content-input",
    attrs: {
      "type": "text",
      "placeholder": "搜索订单号"
    },
    domProps: {
      "value": (_vm.pageInfo.orderNo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pageInfo, "orderNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-btn click",
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, [_c('div', _vm._l((_vm.data), function(item) {
    return _c('div', {
      staticClass: "table-item"
    }, [_c('div', {
      staticClass: "pd-250 bd-bot"
    }, [_c('div', {
      staticClass: "fs-30 color-333"
    }, [_vm._v(_vm._s(item.day + ' ' + item.time))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-between mt-25"
    }, [_c('div', {
      staticClass: "fs-32 color-333"
    }, [_vm._v("用户名：" + _vm._s(item.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "fs-32 color-org"
    }, [_vm._v("￥" + _vm._s(item.paidIn || 0))])]), _vm._v(" "), (item.videoUrlView || item.orderId) ? _c('div', {
      staticClass: "item-btns"
    }, [_c('div', {
      staticClass: "click btn",
      on: {
        "click": function($event) {
          return _vm.showVideo(item)
        }
      }
    }, [_vm._v("视频查看")]), _vm._v(" "), (item.orderId) ? _c('div', {
      staticClass: "click btn",
      on: {
        "click": function($event) {
          _vm.getScrollerPosition();
          _vm.$router.push({
            name: 'orderDetail',
            query: {
              orderId: item.orderId
            }
          })
        }
      }
    }, [_vm._v("订单查看")]) : _vm._e()]) : _vm._e()])
  }), 0)])], 1), _vm._v(" "), _c('navs', {
    attrs: {
      "shopId": _vm.shopId
    }
  }), _vm._v(" "), _c('van-dialog', {
    on: {
      "close": _vm.closeDialog
    },
    model: {
      value: (_vm.videoShow),
      callback: function($$v) {
        _vm.videoShow = $$v
      },
      expression: "videoShow"
    }
  }, [_c('div', {
    staticClass: "video-box"
  }, [_c('div', {
    staticClass: "video-text",
    on: {
      "click": function($event) {
        return _vm.getVideo(0)
      }
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("开门视频")]), _vm._v(" "), (_vm.entity.openVideoView == '未上传') ? _c('div', {
    staticClass: "right"
  }, [(!_vm.openVideoLoading) ? _c('span', [_vm._v("点击上传")]) : _c('span', [_vm._v("正在上传，请等待")])]) : _vm._e()]), _vm._v(" "), (_vm.entity.openVideoView != '未上传' && _vm.entity.openVideoView != '') ? _c('div', {
    staticClass: "video"
  }, [_c('video', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "controls": "controls",
      "src": _vm.entity.openVideoView
    }
  }, [_vm._v("\n                    您的浏览器不支持 video 标签。\n                ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "video-box"
  }, [_c('div', {
    staticClass: "video-text",
    on: {
      "click": function($event) {
        return _vm.getVideo(1)
      }
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("关门视频")]), _vm._v(" "), (_vm.entity.closeVideoView == '未上传') ? _c('div', {
    staticClass: "right"
  }, [(!_vm.closeVideoLoading) ? _c('span', [_vm._v("点击上传")]) : _c('span', [_vm._v("正在上传，请等待")])]) : _vm._e()]), _vm._v(" "), (_vm.entity.closeVideoView != '未上传' && _vm.entity.closeVideoView != '') ? _c('div', {
    staticClass: "video"
  }, [_c('video', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "controls": "controls",
      "src": _vm.entity.closeVideoView
    }
  }, [_vm._v("\n                    您的浏览器不支持 video 标签。\n                ")])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4d91464","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/equipment/openLogList.vue
// module id = J/3F
// module chunks = 51